const handles_errors = {
    methods: {
        clear_all_errors () {
            this.errors = {}
        },
        clear_error (error_id) {
            if(this.errors[error_id]) this.$delete(this.errors, error_id)
        },
        add_error (error_id, message) {
            if(!message) this.clear_error(error_id)
            else this.$set(this.errors, error_id, message)
        },
        has_error (error_id) {
            if(error_id) return this.errors[error_id]
            return !!Object.keys(this.errors).length
        }
    },
    data () {
        return {
            errors: {}
        }
    }
}

export default handles_errors
